/**
 * Class representing Content returned from the Content Delivery Service.
 * The body property will contain the properties specified by the JSON schema content type.
 * Any linked content items will be included inline in the body.
 */
export class ContentItem {
    /**
     * Returns a plain JSON version of the content body, removing helper properties and functions.
     * This should be used if your application needs to serialize the content body, e.g. in an API response.
     */
    toJSON() {
        return JSON.parse(JSON.stringify(this.body));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudEl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbnRlbnQvbW9kZWwvQ29udGVudEl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7Ozs7R0FJRztBQUNILE1BQU0sT0FBTyxXQUFXO0lBT3RCOzs7T0FHRztJQUNILE1BQU07UUFDSixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztJQUMvQyxDQUFDO0NBQ0YifQ==